var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConversationBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4,23a1.276,1.276,0,0,1-1.279-1.135l-.008-.146V8.943A3.838,3.838,0,0,1,8.944,5.11H19.166A3.838,3.838,0,0,1,23,8.943v6.389a3.837,3.837,0,0,1-3.834,3.833H10.75L7.292,22.623A1.255,1.255,0,0,1,6.4,23ZM7.666,8.943v9.69l1.653-1.65a1.291,1.291,0,0,1,.735-.362l.168-.011h8.945a1.278,1.278,0,0,0,1.278-1.278V8.943a1.279,1.279,0,0,0-1.278-1.278H8.944A1.28,1.28,0,0,0,7.666,8.943ZM.008,11.648,0,11.5V3.833A3.833,3.833,0,0,1,3.608.007L3.833,0H11.5a1.278,1.278,0,0,1,.15,2.547l-.15.008H3.833A1.278,1.278,0,0,0,2.565,3.684l-.009.148V11.5a1.278,1.278,0,0,1-2.547.149Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConversationBubble);
export default __webpack_public_path__ + "static/media/Icon-conversation-bubble.860e629dea94c88c2f660fb890f73b1c.svg";
export { ForwardRef as ReactComponent };